import { apiClient } from './apiClient';
import { MarketSummary, MarketEvent } from '../types/marketInsights';

export class MarketInsightsService {
  // ────────────────────────────────────────────────────────────────────────────
  // Summaries
  // ────────────────────────────────────────────────────────────────────────────

  static async getSummaries(): Promise<MarketSummary[]> {
    return apiClient.get<MarketSummary[]>('/market-insights/summaries');
  }

  static async getLatestSummary(): Promise<MarketSummary | null> {
    return apiClient.get<MarketSummary | null>('/market-insights/summaries/latest');
  }

  static async getSummaryById(id: string): Promise<MarketSummary> {
    return apiClient.get<MarketSummary>(`/market-insights/summaries/${id}`);
  }

  static async createSummary(
    summary: Omit<MarketSummary, 'ID' | 'CreatedAt' | 'UpdatedAt' | 'CreatedBy'>
  ): Promise<MarketSummary> {
    return apiClient.post<MarketSummary>('/market-insights/summaries', summary);
  }

  static async updateSummary(id: string, summary: Partial<MarketSummary>): Promise<MarketSummary> {
    return apiClient.put<MarketSummary>(`/market-insights/summaries/${id}`, summary);
  }

  static async deleteSummary(id: string): Promise<void> {
    return apiClient.delete(`/market-insights/summaries/${id}`);
  }

  // ────────────────────────────────────────────────────────────────────────────
  // Events
  // ────────────────────────────────────────────────────────────────────────────

  static async getEvents(): Promise<MarketEvent[]> {
    return apiClient.get<MarketEvent[]>('/market-insights/events');
  }

  static async getUpcomingEvents(): Promise<MarketEvent[]> {
    return apiClient.get<MarketEvent[]>('/market-insights/events/upcoming');
  }

  static async getEventById(id: string): Promise<MarketEvent> {
    return apiClient.get<MarketEvent>(`/market-insights/events/${id}`);
  }

  static async createEvent(
    event: Omit<MarketEvent, 'ID' | 'CreatedAt' | 'UpdatedAt' | 'CreatedBy'>
  ): Promise<MarketEvent> {
    return apiClient.post<MarketEvent>('/market-insights/events', event);
  }

  static async updateEvent(id: string, event: Partial<MarketEvent>): Promise<MarketEvent> {
    return apiClient.put<MarketEvent>(`/market-insights/events/${id}`, event);
  }

  static async deleteEvent(id: string): Promise<void> {
    return apiClient.delete(`/market-insights/events/${id}`);
  }
}
